/*
 * @Author: your name
 * @Date: 2020-10-20 10:27:46
 * @LastEditTime: 2021-01-13 18:39:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-consumer-platform/src/utils/webSocket/wsMiddle.js
 */

/**
 * 使用方法
 *  1.在ProxyConfig配置好相关参数
 *  2.直接this.WebSocket.XXX生成链接，返回promise
 *      注：若需要参数，this.WebSocket.XXX（params）
 *  3.调用this.WebSocket.XXX.getWebSocketPool返回对应连接、连接组
 */
import WebSocketPool from './wsBase'; // 引入webscoket

import MessageHandler from './messageHandle';
import { getOpenPageDom } from '@/fetch/api/openPage.js';
const WEB_SOCKET = {
  install(webSocketList) {
    webSocketList.forEach(v => {
      let webSocketPool = WebSocketPool(); // 先在message中注册此条连接信息

      MessageHandler.install(webSocketPool, v);

      WEB_SOCKET[v.name] = async params => {
        let url = (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + (await WEB_SOCKET.getUrl()); // let url = v.url && 'ws://netty.dev.yunduoketang.cn' + v.url;
        // let url = v.url && 'ws://172.16.101.135:18888' + v.url;

        if (params) {
          Object.keys(params).reduce((str, key, index) => `${str}${key}=${params[key]}${Object.keys(params).length - 1 !== index && '&' || ''}`, `${url}?`);
        }

        let size = v.size || 1;
        webSocketPool.hasStart = false;
        await webSocketPool.start(url, size);
        webSocketPool.hasStart = true;
      };
    });
  },

  async getUrl() {
    // 获取地址
    let url = '';
    await getOpenPageDom().then(res => {
      if (res.code == '1') {
        url = res.data.netty.domain;
      }
    });
    return url;
  }

};
export default WEB_SOCKET;